import React from 'react';
import {Button} from 'onboarding-components';
import clsx from 'clsx';

import {useTranslation} from 'common/i18n/hooks';
import {Translatable} from 'common/i18n';
import {QuestionOption} from 'common/onboarding/segmented-onboarding/types';
import {TileButton} from 'common/onboarding/components/tile-button';

import styles from './index.module.styl';

type ButtonsProps = {
  onNext?: () => void;
  onPrevious?: () => void;
  isNextEnabled: boolean;
  onSubmit?: () => void;
  onFinish?: () => void;
  onLater?: () => void;
  darkMode?: boolean;
  hasPreviousResponse?: boolean;
};
export const Buttons = ({
  isNextEnabled,
  onNext,
  onPrevious,
  onSubmit,
  onFinish,
  onLater,
  darkMode,
  hasPreviousResponse,
}: ButtonsProps) => {
  const {t} = useTranslation();

  return (
    <div className={styles.buttons}>
      {onLater && (
        <Button
          className={styles.overrideBtn}
          variant={!darkMode ? `transparent` : undefined}
          size='small'
          onClick={onLater}
        >
          {t(`signup.name.later`)}
        </Button>
      )}
      {onPrevious && (
        <Button className={styles.overrideBtn} variant='transparent' size='small' onClick={onPrevious}>
          {t(`common.back`)}
        </Button>
      )}
      {onNext && (
        <Button className={styles.overrideBtn} onClick={onNext} size='small' disabled={!isNextEnabled}>
          {t(hasPreviousResponse ? `common.done` : `common.next`)}
        </Button>
      )}
      {onSubmit && (
        <Button className={styles.overrideBtn} size='small' disabled={!isNextEnabled} onClick={onSubmit}>
          {t(`common.submit`)}
        </Button>
      )}
      {onFinish && (
        <Button className={styles.overrideBtn} size='small' disabled={!isNextEnabled} onClick={onFinish}>
          {t(`signup.thanks.finish`)}
        </Button>
      )}
    </div>
  );
};

type BubbleOptionsProps = {
  className?: string;
  options: QuestionOption[];
  selected: Set<string>; // this is a set for interoperability with the segmented onboarding code
  onSelect: (value: string) => void;
  otherPlaceholder?: Translatable;
  otherInput?: () => React.ReactNode;
};
export function BubbleOptions({
  className,
  options,
  selected,
  onSelect,
  otherPlaceholder,
  otherInput,
}: BubbleOptionsProps) {
  const {t, print} = useTranslation();

  return (
    <div className={clsx(styles.optionWrapper, styles.stackBubbles)}>
      {options.map((option) => (
        <TileButton
          className={className}
          key={option.value}
          onClick={() => onSelect(option.value)}
          fullWidthOnMobile={false}
          selected={selected.has(option.value)}
        >
          {print(option.label)}
        </TileButton>
      ))}
      {otherPlaceholder && (
        <>
          <TileButton
            className={className}
            onClick={() => onSelect(`Other`)}
            fullWidthOnMobile={false}
            selected={selected.has(`Other`)}
          >
            {t(`signup.work.option.other`)}
          </TileButton>
          {otherInput && otherInput()}
        </>
      )}
    </div>
  );
}
